/* istanbul ignore file */
import KatalLogger, { Level } from '@amzn/katal-logger';
import { errorOf } from 'src/util/errors';

const katalLoggerConfig = {
  url: '/trim-logs',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false,
};

export const logger = new KatalLogger(katalLoggerConfig);

/**
 * Logs a message using Katal logger, adding additional context to the logging request.
 *
 * @param level - The log level.
 * @param message - The message to log.
 * @param error - An optional error to log.
 */
const log = (level: Level, message: string, error?: unknown) => {

  const finalError = errorOf(error);
  logger[level](message, finalError, { location: window.location.href });
};

export const logDebug = (message: string, error?: unknown) => log(Level.DEBUG, message, error);
export const logInfo = (message: string, error?: unknown) => log(Level.INFO, message, error);
export const logWarning = (message: string, error?: unknown) => log(Level.WARN, message, error);
export const logError = (message: string, error?: unknown) => log(Level.ERROR, message, error);
export const logFatal = (message: string, error?: unknown) => log(Level.FATAL, message, error);

